export default __webpack_public_path__ + "static/media/bsc.ac61f04a.svg";